import * as angular from 'angular';
import Controller from './viewChat.controller';
import template from './viewChat.tpl.html';

export default angular.module('aps.directive.viewChat', [Controller])
  .directive('apsViewChat', viewChatDirective)
  .name;

function viewChatDirective() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'ViewChatCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      count: '=',
      desc: '='
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/chat/viewChat.directive.ts